module.exports = __webpack_public_path__ + "static/header-bg.a9723ba6.png";